import * as React from "react";
import type { SVGProps } from "react";
const ColorPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M18.5 12a6.5 6.5 0 0 1-6.5 6.5v-13a6.5 6.5 0 0 1 6.5 6.5m2 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0" clipRule="evenodd" /></svg>;
export default ColorPanelIcon;